module.exports = __webpack_public_path__ + "media/customizations/lhermitage/logo-new-04e6b1ce7bbe72b956062574f5a8737e.png";